import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { CheckCircle, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdminWhatsApps() {
  const [whatsapps, setWhatsapps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWhatsApps();
  }, []);

  const fetchWhatsApps = async () => {
    try {
      const res = await api.get("/admin/whatsapps");
      setWhatsapps(res.data.whatsapps);
    } catch (error) {
      toast.error("Erro ao carregar WhatsApps");
    } finally {
      setLoading(false);
    }
  };

  const getStatusIcon = (status) => {
    return status === "connected" ? (
      <CheckCircle className="w-5 h-5 text-emerald-500" />
    ) : (
      <XCircle className="w-5 h-5 text-red-500" />
    );
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">WhatsApp</h1>
        <p className="text-zinc-400 mt-1">Status de WhatsApp de todos os clientes</p>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-zinc-800/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Cliente
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Instância
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Mensagens
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">
                  Criado em
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {loading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-zinc-400">
                    Carregando...
                  </td>
                </tr>
              ) : (
                whatsapps.map((wa) => (
                  <tr key={wa.tenant_id} className="hover:bg-zinc-800/30">
                    <td className="px-6 py-4">
                      <div>
                        <div className="font-medium text-white">{wa.user?.name}</div>
                        <div className="text-xs text-zinc-400">{wa.user?.email}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-zinc-400 text-sm">
                      {wa.evolution_instance_name || "-"}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        {getStatusIcon(wa.evolution_status)}
                        <span className="text-sm text-zinc-400 capitalize">
                          {wa.evolution_status || "disconnected"}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-zinc-400">
                      {wa.message_count || 0}
                    </td>
                    <td className="px-6 py-4 text-zinc-400 text-sm">
                      {new Date(wa.created_at).toLocaleDateString("pt-BR")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
